import { z } from 'zod'

export const TripMockMetadataZ = z.object({
	endpoints: z.array(z.string()),
	mock_options: z.record(z.string(), z.array(z.string())),
})

export type TripMockMetadata = z.infer<typeof TripMockMetadataZ>
